<template>
    <v-card outlined style="overflow: hidden">
        <v-select
            v-model="query['type']"
            v-bind="{
                items,
            }"
            prefix="주문유형"
            placeholder="전체"
            multiple
            clearable
            flat
            dense
            solo
            hide-details
            chips
            small-chips
            persistent-placeholder
            class="purchase-list-types"
            @input="emit"
        />
    </v-card>
</template>

<script>
import { PURCHASE_TYPES } from "@/assets/variables";

const items = Object.values(PURCHASE_TYPES);

const initQuery = (query = {}) => ({
    ...query,
    ["type"]: [query?.["type"]].flat().filter((item) => !!item),
});

export default {
    setup: () => ({
        items,
    }),
    data: () => ({
        query: initQuery(),
    }),
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query["type"]) delete query[type];

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.purchase-list-types {
    font-size: 12px;
    margin: -1px 0;
}
</style>
